import React, { useEffect, useState } from 'react';
import { Typography, Button, Segmented, Table } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import api from '../api';
import HelpdeskInvolvedTickets, { involvedTicketColumns } from '../components/HelpdeskInvolvedTickets';
import HelpdeskCreateModal from '../components/HelpdeskCreateModal';

// My HelpDesk for a client's own login (Role 'client'): My Tickets (raised,
// impacted or watching) or My Company's Tickets -- every Client Ticket Type
// ticket of their Client Contact's clients (GET /api/helpdesk?company=1).
// Staff use MyHelpdeskPage.
export default function MyHelpdeskClientsPage() {
  const navigate = useNavigate();
  const [view, setView] = useState('mine');
  const [createOpen, setCreateOpen] = useState(false);
  const [filterOpts, setFilterOpts] = useState({ teams: [], users: [] });
  const [company, setCompany] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    api.get('/api/helpdesk/filter-options').then((r) => setFilterOpts(r.data)).catch(() => {});
  }, []);
  useEffect(() => {
    if (view !== 'company') return;
    setLoading(true);
    api.get('/api/helpdesk', { params: { company: 1 } })
      .then((r) => setCompany(r.data || []))
      .catch(() => setCompany([]))
      .finally(() => setLoading(false));
  }, [view]);

  return (
    <div>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 12, gap: 12, flexWrap: 'wrap' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 12, flexWrap: 'wrap' }}>
          <Typography.Title level={4} style={{ margin: 0 }}>My HelpDesk</Typography.Title>
          <Segmented value={view} onChange={setView} options={[
            { value: 'mine', label: 'My Tickets' },
            { value: 'company', label: "My Company's Tickets" },
          ]} />
        </div>
        <Button type="primary" icon={<PlusOutlined />} onClick={() => setCreateOpen(true)}>New Ticket</Button>
      </div>
      {view === 'mine' ? <HelpdeskInvolvedTickets /> : (
        <Table
          rowKey="ID"
          size="small"
          loading={loading}
          dataSource={company}
          columns={involvedTicketColumns(company, { showRole: false, showEmployee: true, employeeTitle: 'Raised By' })}
          pagination={{ defaultPageSize: 25, size: 'small', showSizeChanger: true, pageSizeOptions: ['25', '50', '100', '200'],
            showTotal: (t) => `${t} ticket${t === 1 ? '' : 's'}` }}
          locale={{ emptyText: 'No tickets.' }}
          scroll={{ x: 'max-content' }}
          onRow={(r) => ({ onClick: () => navigate(`/helpdesk/${r.ID}`), style: { cursor: 'pointer' } })}
        />
      )}
      <HelpdeskCreateModal open={createOpen} onClose={() => setCreateOpen(false)} filterOpts={filterOpts} />
    </div>
  );
}
